/**
 * Намір відкрити рядок списку (UX-33): наведення довше за `ROW_INTENT_MS` — код картки наперед
 * (`ListSource.preload`). Таймер — через годинник: типово справжній, тест підставляє ручний, стан
 * скидає test/setup.ts. Окремий модуль, щоб setup не тягнув таблицю.
 */
import { type AreaClock, realClock } from '../../ui/area-timeline.ts';

/** Пауза наведення на рядку до попереднього завантаження. */
export const ROW_INTENT_MS = 80;

let current: AreaClock = realClock;

/** Годинник для таблиці, що монтується: таблиця бере його один раз. */
export const rowIntentClock = (): AreaClock => current;

export function setRowIntentClockForTests(clock: AreaClock = realClock): void {
  current = clock;
}
